<template>
    <main id="mainCtrl">
        <PromoDialog ref="dialog" url-type="clinics"/>
        <div class="promo">
            <div class="promo__data">
                <div class="promo__title">Хотите больше пациентов?</div>
                <div class="promo__markers">
                    <div class="promo__marker promo__marker_red">
                        Скидка 50%
                    </div>
                    <div class="promo__marker promo__marker_green">
                        Действует до конца месяца
                    </div>
                </div>
                <div class="promo__text">
                    <p>
                        Подключите приоритетное размещение, чтобы получить поток новых пациентов.
                    </p>
                    <ul>
                        <li>Больше пациентов до 10 раз</li>
                        <li>Приоритетное размещение</li>
                        <li>Реклама врачей и клиники</li>
                        <li>Персональный менеджер</li>
                        <li>Продвижение на картах</li>
                        <li>Обратный звонок</li>
                        <li>Коллтрекинг</li>
                    </ul>
                </div>
                <div class="promo__actions">
                    <a href="#" class="promo__btn" @click.prevent="openDialog">Попробовать</a>

                    <a href="https://doctu.ru/storage.public/files/Презентация%20ДОКТУ.pdf"
                       target="_blank"
                       @click="sendMetrik('LK_PROMO_PDF')"
                       class="promo__link">
                        Скачать презентацию
                    </a>
                </div>
            </div>
            <div class="promo__img">
                <img src="/img/lustra.svg" alt="" />
            </div>
        </div>
    </main>
</template>

<script>
import PromoDialog from "@dialogs/Promo";

export default {
    components: {
        PromoDialog
    },
    methods: {
        openDialog() {
            this.sendMetrik('LK_PROMO_BTN');
            this.$refs.dialog.show();
        },
        sendMetrik: function (action){
            const yaCounter = window['yaCounter97357971'];
            if (yaCounter !== undefined) {
                yaCounter.reachGoal(action);
            }
        }
    },
    mounted() {
        this.sendMetrik('LK_PROMO');
    }
}
</script>
